

import { useEffect, useRef, useState } from 'react';
import { Dashboard, Category, ShoppingCart, Receipt, Payment, Menu, AccountCircle, Campaign ,ExpandMor, Settings, AddBox , Inventory, ShoppingCartCheckout, Payments, PendingActions, ExpandMore, Notifications } from '@mui/icons-material';
import './AdminDashboard.css';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import { useNavigate } from 'react-router-dom';
import ManageCategories from './ManageCategories';
import ManageProductTypes from './ManageProductTypes';
import ManageProducts from './ManageProducts';
import ProductsView from './ProductsView';
import AdvertisementForm from './Advertisement';
import ManageNotifications from './ManageNotifications';
import HistoryIcon from '@mui/icons-material/History';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

import NotificationHistory from './NotificationHistory';
import ManageMetalRates from './ManageMetalRates';

export default function AdminDashboard() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [isProductCategoryOpen, setIsProductCategoryOpen] = useState(false);
  const [isProductMenuOpen, setIsProductMenuOpen] = useState(false);

  const [activeComponent, setActiveComponent] = useState('dashboard');

  const startX = useRef(0);
  const currentX = useRef(0);
  const isDragging = useRef(false);



  useEffect(() => {
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchmove', handleTouchMove);
    window.addEventListener('touchend', handleTouchEnd);
    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchmove', handleTouchMove);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
    currentX.current = startX.current;
    isDragging.current = true;
  };

  const handleTouchMove = (e) => {
    if (!isDragging.current) return;
    currentX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = () => {
    if (!isDragging.current) return;
    const diffX = currentX.current - startX.current;
    if (diffX > 50) {
      setIsSidebarOpen(true); // Swipe Right to Open
    } else if (diffX < -50) {
      setIsSidebarOpen(false); // Swipe Left to Close
    }
    isDragging.current = false;
  };


  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleProductCategoryMenu = () => {
    setIsProductCategoryOpen(!isProductCategoryOpen);
  };

  const navigate = useNavigate();

  const toggleProfileMenu = () => {
    setIsProfileOpen(!isProfileOpen);
  };

  const handleLogout = () => {
    navigate('/admin-login');
  };

  const data = [
    { name: 'Jan', Orders: 30, Payments: 45000 },
    { name: 'Feb', Orders: 50, Payments: 70000 },
    { name: 'Mar', Orders: 40, Payments: 60000 },
    { name: 'Apr', Orders: 60, Payments: 90000 },
    { name: 'May', Orders: 45, Payments: 68000 },
    { name: 'Jun', Orders: 70, Payments: 110000 },
    { name: 'Jul', Orders: 55, Payments: 75000 },
    { name: 'Aug', Orders: 65, Payments: 98000 },
    { name: 'Sep', Orders: 50, Payments: 72000 },
    { name: 'Oct', Orders: 80, Payments: 130000 },
    { name: 'Nov', Orders: 90, Payments: 150000 },
    { name: 'Dec', Orders: 100, Payments: 170000 },
  ];


  const renderContent = () => {
    switch (activeComponent) {
      case 'manage-categories':
        return <ManageCategories />;
      case 'manage-product-types':
        return <ManageProductTypes />;
      case 'manage-products':
        return <ManageProducts/>;
         case 'manage-products':
      return <ManageProducts />;
      case 'manage-notifications':
        return <ManageNotifications/>
        case 'notification-history':
          return <NotificationHistory/>
        case 'manage-metal-rates':
          return <ManageMetalRates/>
    case 'products-view':
      return <ProductsView />;
          case 'advertisement':
      return <AdvertisementForm />;
      default:
        return (
          <>
            <div className="dashboard-cards">
              <div className="card"><div className="card-icon"><Inventory /></div><h3>Total Products</h3><p>120</p></div>
              <div className="card"><div className="card-icon"><ShoppingCartCheckout /></div><h3>Total Orders</h3><p>85</p></div>
              <div className="card"><div className="card-icon"><Payments /></div><h3>Total Payments</h3><p>₹1,50,000</p></div>
              <div className="card"><div className="card-icon"><PendingActions /></div><h3>Pending Orders</h3><p>12</p></div>
            </div>
            <section className="dashboard-analytics">
              <h2>Orders & Payments Analytics</h2>
              <ResponsiveContainer width="100%" height={300}>
                <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="Orders" fill="#3d0c4e" radius={[10, 10, 0, 0]} />
                  <Bar dataKey="Payments" fill="#9c54a6" radius={[10, 10, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </section>
          </>
        );
    }
  };

  return (
    <div className="dashboard-containerr">
      <aside className={`sidebarr ${isSidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-headerr">
          {isSidebarOpen && <span className="logo">SPINELLE ✦</span>}

          <Menu className="hamburgerr" onClick={toggleSidebar} />
        </div>
        <nav className="sidebar-menuu">
          <div className="menu-itemm" onClick={() => { setActiveComponent('dashboard'); if(window.innerWidth <= 768) setIsSidebarOpen(false); }}>

            <Dashboard />{isSidebarOpen && <span>Dashboard</span>}
          </div>
              <div className="menu-itemm" onClick={() => { setActiveComponent('advertisement'); if(window.innerWidth <= 768) setIsSidebarOpen(false); }}>

            <Campaign  />{isSidebarOpen && <span>Advertisement</span>}
          </div>
            <div className="menu-itemm" onClick={() => { setActiveComponent('manage-notifications'); if(window.innerWidth <= 768) setIsSidebarOpen(false); }}><Notifications />{isSidebarOpen && <span>Manage Notifications</span>}</div>
          <div className="menu-itemm" onClick={() => { setActiveComponent('notification-history'); if(window.innerWidth <= 768) setIsSidebarOpen(false); }}><HistoryIcon />{isSidebarOpen && <span>Notifications History </span>}</div>
          <div className="menu-itemm" onClick={() => { setActiveComponent('manage-metal-rates'); if(window.innerWidth <= 768) setIsSidebarOpen(false); }}><TrendingUpIcon />{isSidebarOpen && <span>Manage MetalRates</span>}</div>
       <div className="menu-itemm" onClick={toggleProductCategoryMenu}>
  <Category />{isSidebarOpen && <span>Product Category</span>}
  {isSidebarOpen && <ExpandMore className={`dropdown-iconn ${isProductCategoryOpen ? 'open' : ''}`} />}
</div>

          {isProductCategoryOpen && (
            <div className={`submenuu ${isSidebarOpen ? 'open' : 'collapsed'}`}>
              <div className="submenu-itemm" onClick={() => { setActiveComponent('manage-categories'); if(window.innerWidth <= 768) setIsSidebarOpen(false); }}><AddBox />{isSidebarOpen && <span>Manage Categories</span>}</div>
              <div className="submenu-itemm" onClick={() => {setActiveComponent('manage-product-types'); if(window.innerWidth <= 768) setIsSidebarOpen(false); }}><Settings />{isSidebarOpen && <span>Manage Product Types</span>}</div>
            </div>
          )}
         <div className="menu-itemm" onClick={() => setIsProductMenuOpen(!isProductMenuOpen)}>
  <ShoppingCart />{isSidebarOpen && <span>Products</span>}
  {isSidebarOpen && <ExpandMore className={`dropdown-icon ${isProductMenuOpen ? 'open' : ''}`} />}
</div>

{isProductMenuOpen && (
  <div className={`submenuu ${isSidebarOpen ? 'open' : 'collapsed'}`}>
    <div className="submenu-itemm" onClick={() => { setActiveComponent('manage-products'); if(window.innerWidth <= 768) setIsSidebarOpen(false); }}>
      <AddBox />{isSidebarOpen && <span>Add Product</span>}
    </div>
    <div className="submenu-itemm" onClick={() => { setActiveComponent('products-view'); if(window.innerWidth <= 768) setIsSidebarOpen(false); }}>
      <Inventory />{isSidebarOpen && <span>Products View</span>}
    </div>
  </div>
)}

          <div className="menu-itemm"><Receipt />{isSidebarOpen && <span>Orders</span>}</div>
          <div className="menu-itemm"><Payment />{isSidebarOpen && <span>Payments</span>}</div>
        </nav>
      </aside>

      <main className="main-contentt">
        <header className="dashboard-headerr">
          {!isSidebarOpen && <Menu className="hamburgerr" onClick={toggleSidebar} />}
          <h1>Admin Dashboard</h1>
          <div className="profile-containerr">
            <AccountCircle className="profile-iconn" onClick={toggleProfileMenu} />
            {isProfileOpen && (
              <div className="profile-dropdownn">
                <div className="dropdown-itemm" onClick={handleLogout}>Logout</div>
              </div>
            )}
          </div>
        </header>
        <section className="dashboard-bodyy">
          {renderContent()}
        </section>
      </main>
    </div>
  );
}
